// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c36b44e","732":"ca8af329"}[chunkId] + ".chunk.js";
};